import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon';
import { Icons } from '~/components/Icon/constants';
import styles from '~/components/Player/MiniPlayer/styles';
import usePlayerProps from '~/components/Player/hooks/usePlayerProps';

export const ExpandPlayerButton = (): JSX.Element => {
  const { onOpen } = usePlayerProps();
  const { t } = useTranslation();

  return (
    <button
      type="button"
      css={styles.expandBtn}
      onClick={onOpen}
      aria-label={t('playerControls.accessibilityLabels.openFullPlayer')}
    >
      <Icon ariaHidden name={Icons.CaretUp} sizeInPx={14} />
    </button>
  );
};
